class EventUtils {
    public static readonly addBeforeUnloadEventListener = (): void => {
        window.addEventListener('beforeunload', EventUtils.handleBeforeUnload);
    };

    public static readonly removeBeforeUnloadEventListener = (): void => {
        window.removeEventListener('beforeunload', EventUtils.handleBeforeUnload);
    };

    private static readonly handleBeforeUnload = (event: BeforeUnloadEvent): void => {
        event.preventDefault();
        event.returnValue = '';
    };
}

export { EventUtils };
